'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    sizeChart = require("./sizechart"),
    tealium = require('../../../int_tealium/cartridge/js/tealium/tealium'),
    util = require('./util');

var selectedList = [];
var maxItems = 1;
var bliUUID = '';

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts() {
    var bonusproducts = [];

    var i, len;
    for (i = 0, len = selectedList.length; i < len; i++) {
        var p = {
            pid: selectedList[i].pid,
            qty: selectedList[i].qty,
            masterpid: selectedList[i].masterpid,
            brand: selectedList[i].brand,
            options: {}
        };
        var a, alen, bp = selectedList[i];
        if (bp.options) {
            for (a = 0, alen = bp.options.length; a < alen; a++) {
                var opt = bp.options[a];
                p.options = {optionName:opt.name, optionValue:opt.value};
            }
        }
        bonusproducts.push({product:p});
    }
    return {bonusproducts: bonusproducts};
}

var selectedItemTemplate = function (data) {
    var attributes = '';
    for (var attrID in data.attributes) {
        var attr = data.attributes[attrID];
        attributes += '<li data-attribute-id="' + attrID + '">\n';
        attributes += '<span class="display-name">' + attr.displayName + '</span>: ';
        attributes += '<span class="display-value">' + attr.displayValue + '</span>\n';
        attributes += '</li>';
    }
    attributes += '<li class="item-qty">\n';
    attributes += '<span class="display-name">Qty</span>: ';
    attributes += '<span class="display-value">' + data.qty + '</span>';
    return [
        '<li class="selected-bonus-item" data-uuid="' + data.uuid + '" data-masteruuid="' + data.masteruuid + '" data-pid="' + data.pid + '" data-brand="' + data.brand + '" data-masterpid="' + data.masterpid + '">',
        '<i class="remove-link fa fa-remove" title="Remove this product" href="#"></i>',
        '<div class="item-name">' + data.name + '</div>',
        '<ul class="item-attributes">',
        attributes,
        '<ul>',
        '<li>'
    ].join('\n');
};
function dropdownswatch() {
	var selecting = ".bonus-product-quickview .product-variations .attribute .value .selecting";
	$("body").off("click", selecting ).on("click", selecting, function(e) {
        e.stopPropagation();
        var $curObj = $(this).closest(".value"),
        	$curSwatch =$curObj.find('.swatches'),
        	$curSelecting = $curObj.find('.selecting'),
        	$curparent = $curSelecting.closest('.attributeinfo'),
        	$allSwatches = $('.bonus-product-quickview .product-variations .attribute'),
        	$variationObj = $(this).closest('.bonus-product-items');
        	/*var bonusOverlayHeight = $variationObj.height();
        	if ( $(this).closest('.bonus-product-item').hasClass('lastitem') ) {
        		$variationObj.animate({scrollTop: bonusOverlayHeight}, 500);
        	} */
	        if((!$curSwatch.hasClass('active')) && (!$curSelecting.hasClass('active'))) {
	        	$allSwatches.find('.swatches').removeClass('active');
		        $allSwatches.find('.selecting').removeClass('active');
		        $allSwatches.find('.selecting').closest('.attributeinfo').removeClass('active');
	        	$curSwatch.addClass('active');
	        	$curSelecting.addClass('active');
	        	$curSelecting.addClass('info');
	        	$curparent.addClass('active');
	        	if($curSwatch.find('li').length < 1) {
	        		$curSwatch.css('height','100%');
	        	}
	        	var valueswatch = $curSelecting.text().substr(0,6);
	        	if(valueswatch=="Select") {
	        		$curSelecting.text($curObj.data('attrinfo'));
	        		$curSelecting.addClass('active');
	        		$curparent.addClass('active');
	        		var selectedswatch = $curSwatch.find('li.selected').text();
	        	}	
        	} else {
        		$curSwatch.removeClass('active');
        		$curSelecting.removeClass('active');
        		$curSelecting.removeClass('info');
        		$curparent.removeClass('active');
        	}
	  });
	
	  $("body").on("click", function(a) {
		  var $swatchclose = $('.bonus-product-quickview .product-variations .attribute');
		  $swatchclose.find('.swatches').is(":visible") && $swatchclose.find('.swatches').removeClass('active');
		  $swatchclose.find('.selecting').removeClass('active');
		  $swatchclose.find('.selecting').closest('.attributeinfo').removeClass('active');
	   });
}
// hide swatches that are not selected or not part of a Product Variation Group
var hideSwatches = function () {
	$('.bonus-product-item:not([data-producttype="master"]) .swatches li').not('.selected').not('.variation-group-value').hide();
    // prevent unselecting the selected variant
    // SM-4702: Removed condition to not allow changing the variant below
    //$('.bonus-product-item .swatches .selected').on('click', function () {
    //    return false;
    //});
    //Choice of product-bonus 
    dropdownswatch();  
};

/**
 * @private
 * @function
 * @description Updates the summary page with the selected bonus product
 */
function updateSummary() {
    var $bonusProductList = $('#bonus-product-list');
    if (!selectedList.length) {
        $bonusProductList.find('li.selected-bonus-item').remove();
    } else {
        var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
        ulList.html('');
        var i, len;
        for (i = 0, len = selectedList.length; i < len; i++) {
            var item = selectedList[i];
            var li = selectedItemTemplate(item);
            $(li).appendTo(ulList);
        }
    }

    // get remaining item count
    var remain = maxItems - selectedList.length;
    $bonusProductList.find('.bonus-items-available').text(remain);
    if (remain <= 0) {
        //$bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    } else {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
    }
}

function readmore($curBonusLineItem) {
	var showChar, ellipsestext, moretext, content, lesstext, characters, hiddencharacter;
	var showChar = 250;  // How many characters are shown by default
    ellipsestext = "...";
    moretext = " View More";
    lesstext = " View Less";
    var $curDes = $curBonusLineItem.find('.product-desc');
    if (!$curDes.hasClass('read-more-applied')) {
    	content = $curDes.text();
        if(content.length > showChar) {
            var characters = content.substr(0, showChar);
            var hiddencharacter = content.substr(showChar, content.length - showChar);
            var html = characters + '<span class="morecontent" style="display:none;"><span class="hiddentext" style="display:none;">' + hiddencharacter + '</span></span><a href="" class="morelink d-block w-auto">' + moretext + '</a>';
            $curDes.html(html);
            $curDes.find(".morelink").click(function(){
    	        if($(this).hasClass("less")) {
    	            $(this).removeClass("less");
    	            $(this).html(moretext);
    	        } else {
    	            $(this).addClass("less");
    	            $(this).html(lesstext);
    	        }
    	        $(this).parent().find('.morecontent,.hiddentext').toggle();
    	        return false;
    	    });
    	    $curDes.addClass('read-more-applied');
        }
    }   
}

// SM-4702: Took duplicate logic and put it in it's own method
function handleBonusCheckboxClick(bonusCheckbox) {
    if ($(bonusCheckbox).is(':checked')) {
        // SM-4702 - added code to uncheck the other checkboxes
        $(bonusCheckbox).parent('.bonus-product-item').siblings().find('input[type="checkbox"]').attr("checked", false);
        $(bonusCheckbox).parent('.bonus-product-item').siblings().find('input[type="checkbox"]').each(function() {
            handleRemoveBonusItem($(this));    
        });            
        $(bonusCheckbox).parent('.bonus-product-item').find('.product-col-2 button.select-bonus-item').trigger('click');
    } else {
        handleRemoveBonusItem(bonusCheckbox);
    }
}

function handleRemoveBonusItem(bonusCheckbox) {
    var uuid = $(bonusCheckbox).val();
    if ($(bonusCheckbox).parents('.bonus-product-list').find('.bonus-product-list-footer li[data-uuid="'+uuid+'"] .remove-link').length > 0) {
        $(bonusCheckbox).parents('.bonus-product-list').find('.bonus-product-list-footer li[data-uuid="'+uuid+'"] .remove-link').trigger('click');
    } else {
        $(bonusCheckbox).parents('.bonus-product-list').find('.bonus-product-list-footer li[data-masteruuid="'+uuid+'"] .remove-link').trigger('click');
    }
}

function initializeGrid () {
    var $bonusProduct = $('#bonus-product-dialog'),
        $bonusProductList = $('#bonus-product-list'),
        bliData = $bonusProductList.data('line-item-detail');
    maxItems = bliData.maxItems;
    bliUUID = bliData.uuid;
    $('.bonus-product-item').each(function(){
    	var $curBonusLineItem = $(this);
    	readmore($curBonusLineItem);
    });

    if (bliData.itemCount >= maxItems) {
       // $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    }

    var cartItems = $bonusProductList.find('.selected-bonus-item');
    cartItems.each(function () {
        var ci = $(this);
        var product = {
            uuid: ci.data('uuid'),
            masteruuid: ci.data('masteruuid'),
            pid: ci.data('pid').toString(),
            qty: ci.find('.item-qty .display-value').text(),
            name: ci.find('.item-name').html(),
            attributes: {}
        };
        var attributes = ci.find('ul.item-attributes li');
        attributes.each(function () {
            var li = $(this);
            product.attributes[li.data('attributeId')] = {
                displayName:li.children('.display-name').html(),
                displayValue:li.children('.display-value').html()
            };
        });
        selectedList.push(product);
    });

    $bonusProductList.on('click', '.bonus-product-item a[href].swatchanchor', function (e) {
        e.preventDefault();
        var url = this.href,
            $this = $(this);
        
        //Don't exceute the ajax call if user is trying to select the previous selected swatch. 
        if ($this.parents('li').is('.selected')) {
            return;
        }
        var isselected = $(this).parents('.bonus-product-item').find('input.bonus-check').is(':checked');
        url = util.appendParamsToUrl(url, {
            'source': 'bonus',
            'selecteditem': isselected,
            'format': 'ajax'
        });
        $.ajax({
            url: url,
            success: function (response) {
            	var $curBonusLineItem = $this.closest('.bonus-product-item');
            	$curBonusLineItem.empty().html(response);
                hideSwatches();
                var masteruuid = $(response).find('.masteruuid').val();
                var i, len = selectedList.length;
                for ( i = 0; i < len; i++ ) {
                    if ( selectedList[i].uuid === masteruuid || selectedList[i].masteruuid === masteruuid ) {
                        selectedList.splice(i, 1);
                        break;
                    }
                }
                var currProductUUID= $(response).find("input[name='productUUID']").val();
                
                $bonusProductList.off('click', '.bonus-product-item input[type="checkbox"]').on('click', '.bonus-product-item input[type="checkbox"]', function () {
                    // SM-4702: Updated checkbox behavior and refactored to call a method instead of having duplicate code
                    handleBonusCheckboxClick($(this));
            	});
                $('.selecteditem').each(function(){
                	var $curObj = $(this);
                	if(currProductUUID != null && currProductUUID==$curObj.val() && isselected){
                		var $curBonusLineItem = $curObj.closest('.bonus-product-item');
                		readmore($curBonusLineItem);
                		$curObj.trigger('click');
                	}
                });
            	readmore($curBonusLineItem);
            }
        });
    })
    .on('change', '.input-text', function () {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
        $(this).closest('.bonus-product-form').find('.quantity-error').text('');
    })
    .on('click', '.select-bonus-item', function (e) {
        e.preventDefault();
        if (selectedList.length >= maxItems) {
            // SM-4702: When the list of selected items is greater than maxItems (which we expect to always be one)
            // We'll remove the first item from the list, which should be a previous selection
            selectedList.splice(0,1);
        }

        var form = $(this).closest('.bonus-product-form'),
            detail = $(this).closest('.product-detail'),
            uuid = form.find('input[name="productUUID"]').val(),
            qtyVal = form.find('input[name="Quantity"]').val(),
            ismaster = form.find('input[name="ismaster"]').val(),
            masteruuid = form.find('input[name="masteruuid"]').val(),
            qty = (isNaN(qtyVal)) ? 1 : (+qtyVal);

        if (qty > maxItems) {
           // $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
            return;
        }

        var product = {
            uuid: uuid,
            masteruuid: masteruuid,
            masterpid: form.find('input[name="masterpid"]').val(),
            pid: form.find('input[name="pid"]').val(),
            qty: qty,
            brand:form.find('input[name="cart-brand"]').val(),
            ismaster: ismaster,
            name: detail.find('.product-name').text(),
            attributes: detail.find('.product-variations').data('attributes'),
            options: []
        };

        var optionSelects = form.find('.product-option');

        optionSelects.each(function () {
            product.options.push({
                name: this.name,
                value: $(this).val(),
                display: $(this).children(':selected').first().html()
            });
        });
        selectedList.push(product);
        updateSummary();
    })
    .on('click', '.remove-link', function (e) {
        e.preventDefault(); 
        var container = $(this).closest('.selected-bonus-item');
        if (!container.data('uuid')) { return; }

        var uuid = container.data('uuid');
        var i, len = selectedList.length;
        for (i = 0; i < len; i++) {
            if (selectedList[i].uuid === uuid) {
                selectedList.splice(i, 1);
                break;
            }
        }
        updateSummary();
    })
    .on('click', '.add-to-cart-bonus', function (e) {
        e.preventDefault();
        var isSelected;
        if (selectedList == null || selectedList.length <= 0) {
        	//SM-6880
        	var isSwatchesSelected = true;
        	$bonusProductList.find('.bonus-product-items .bonus-product-item').each(function() {
        		isSelected = $(this).find('input.bonus-check').is(':checked');
        		if (isSelected) {
        			// call a separate function to handle this.
        			isSwatchesSelected = handleSwatchSelectionError($(this));        			
        		}
        	});
        	if (isSwatchesSelected) {
        		$bonusProductList.find('.bonus-product-list-footer .quantity-error').text(Resources.BONUS_PRODUCT_EMPTY).show();	
        	}
        	return false;
        } else {
        	$bonusProductList.find('.bonus-product-list-footer .quantity-error').text('').hide();
        }
        if (selectedList.length > maxItems) {
    		if (maxItems == 1) {
        		$bonusProductList.find('.bonus-product-list-footer .quantity-error').text(Resources.BONUS_PRODUCT_ERROR + " " + maxItems + " " + Resources.BONUS_PRODUCT_SELETED).show();
        	} else {
        		$bonusProductList.find('.bonus-product-list-footer .quantity-error').text(Resources.BONUS_PRODUCT_ERROR + " " + maxItems + " " + Resources.BONUS_PRODUCTS_SELETED).show();
        	}
            return false; 
        } else {
        	$bonusProductList.find('.bonus-product-list-footer .quantity-error').text('').hide();
        }
        
        var i, len = selectedList.length,isvalid = true;
        var arr = [];
        for (i = 0; i < len; i++) {
            if (selectedList[i].ismaster === 'true') {
                 isvalid = false;
                 $('#item-'+selectedList[i].uuid+' .variation-selection-error-msg>span').each(function( index,value){
             		if(arr.indexOf(value.className)==-1){
             			arr.push(value.className);
             		}
             	});
                $('#item-'+selectedList[i].uuid+' .variation-selection-error-msg').each(function(e){
              		$(this).closest('.attribute').find('.label').addClass('errormsg');
             		$(this).closest('.attribute').find('.attributeinfo').addClass('errormsg');
             	});
            }
        }
        
        if ( !isvalid ) {
        	var missingAttr = "";
        	$.each(arr, function(index, value) {
        		if(missingAttr==''){
        			missingAttr = value;
        		}else if(index==arr.length-1){
        			missingAttr = missingAttr +" and "+value;
        		}else{
        			missingAttr = missingAttr +","+value;
        		}
        	});
        	if(missingAttr != ''){
        		$bonusProductList.find('.bonus-product-list-footer .quantity-error').text('Please select '+missingAttr).show();
        	}else{
        		$bonusProductList.find('.bonus-product-list-footer .quantity-error').text('').hide();
        	}
        	return false; 
        }
        
        var url = util.appendParamsToUrl(Urls.addBonusProduct, {bonusDiscountLineItemUUID: bliUUID});
        var bonusProducts = getBonusProducts();
        if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
            bonusProducts.bonusproducts[0].product.qty = maxItems;
        }
        // make the server call
        $.ajax({
            type: 'POST',
            dataType: 'json',
            cache: false,
            contentType: 'application/json',
            url: url,
            data: JSON.stringify(bonusProducts)
        })
        .done(function () {
            // success
        	var product;
        	var prodID = [],prodQty = [],prodMasterId=[], cartBrand = [], productUnitPrice = ["0"];
        	for (var h = 0; h < bonusProducts.bonusproducts.length; h += 1) {
        		product = bonusProducts.bonusproducts[h].product;
        		prodID.push(product.pid);
        		prodMasterId.push(product.masterpid);
        		prodQty.push(product.qty);
        		cartBrand.push(product.brand);
        	}
        	var obj ={
				event_name : "product_gift_add",
				product_id : prodMasterId, 
				product_sku : prodID, 
				product_viewtype : "cart",
				product_unit_price : productUnitPrice, 
				product_quantity : prodQty, 
				product_brand_cart : cartBrand
        	}
        	tealium.triggerEvent(obj);
            window.location.href = Urls.cartShow;
        })
        .fail(function (xhr, textStatus) {
            // failed
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        })
        .always(function () {
            $bonusProduct.dialog('close');
        });
    })
    .on('click', '#more-bonus-products', function (e) {
        e.preventDefault();
        var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;

        //get the next page of choice of bonus products
        var lineItemDetail = JSON.parse($('#bonus-product-list').attr('data-line-item-detail'));
        lineItemDetail.pageStart = lineItemDetail.pageStart + lineItemDetail.pageSize;
        $('#bonus-product-list').attr('data-line-item-detail', JSON.stringify(lineItemDetail));

        var url = util.appendParamsToUrl(Urls.getBonusProducts, {
            bonusDiscountLineItemUUID: uuid,
            format: 'ajax',
            lazyLoad: 'true',
            pageStart: lineItemDetail.pageStart,
            pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
            bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail.bpTotal
        });

        $.ajax({
            type: 'GET',
            cache: false,
            contentType: 'application/json',
            url: url
        })
        .done(function (data) {
            //add the new page to DOM and remove 'More' link if it is the last page of results
            $('#more-bonus-products').before(data);
            if ((lineItemDetail.pageStart + lineItemDetail.pageSize) >= $('#bonus-product-list').data().lineItemDetail.bpTotal) {
                $('#more-bonus-products').remove();
            }
        })
        .fail(function (xhr, textStatus) {
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        });
    })
    .on('click', '.bonus-product-item input[type="checkbox"]', function () {
        // SM-4702: Updated checkbox behavior and refactored to call a method instead of having duplicate code
        handleBonusCheckboxClick($(this));
	});
}

// SM-6880 
function handleSwatchSelectionError (bonusCheckedLineItem) {
    var i, len = bonusCheckedLineItem.length,isvalid = true;
    var $bonusProductList = $('#bonus-product-list');
    var arr = [];
    for (i = 0; i < len; i++) {
        if (bonusCheckedLineItem.attr('data-producttype') === 'master') {
             isvalid = false;
             var itemUUID = bonusCheckedLineItem.attr('id');
             $('#'+itemUUID+' .variation-selection-error-msg>span').each(function( index,value) {
         		if(arr.indexOf(value.className)==-1){
         			arr.push(value.className);
         		}
         	});
            $('#'+itemUUID+' .variation-selection-error-msg').each(function(e) {
          		$(this).closest('.attribute').find('.label').addClass('errormsg');
         		$(this).closest('.attribute').find('.attributeinfo').addClass('errormsg');
         	});
        }
    }
    
    if ( !isvalid ) {
    	var missingAttr = "";
    	$.each(arr, function(index, value) {
    		if(missingAttr==''){
    			missingAttr = value;
    		}else if(index==arr.length-1){
    			missingAttr = missingAttr +" and "+value;
    		}else{
    			missingAttr = missingAttr +","+value;
    		}
    	});
    	if(missingAttr != '') {
    		$bonusProductList.find('.bonus-product-list-footer .quantity-error').text('Please select '+missingAttr).show();
    	}else{
    		$bonusProductList.find('.bonus-product-list-footer .quantity-error').text('').hide();
    		return true;
    	}
    	return false; 
    }
}
var bonusProductsView = {
    /**
     * @function
     * @description Open the list of bonus products selection dialog
     */
    show: function (url) {
        var $bonusProduct = $('#bonus-product-dialog');
        // create the dialog
        dialog.open({
            target: $bonusProduct,
            url: url,
            options: {
                width: 740,
                dialogClass: 'bonus-product-quickview',
                closeOnEscape  : true,
                title: Resources.BONUS_PRODUCTS,
                open: function() {
                    hideSwatches();
                    //initializeGrid();
                    sizeChart.init();
                    /* PXSFCC-4495_WCAG_Modal_focus_management */
                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                    	$(this).focus();
                    });
                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
                    $(".ui-dialog").addClass('legacy-sitegen');
            	}
            },
            callback: function () {
                // SM-4702 moved initializeGrid back to the callback so that the events would attach while editing the free gift
                initializeGrid();
                hideSwatches();
                $('.ui-widget-overlay').bind('click', function() { 
                    $('#bonus-product-dialog').dialog('close');
                });
                $('.bonus-product-item').each(function(){
                	var $curBonusLineItem = $(this);
                	readmore($curBonusLineItem);
                });
            }
        });
    },
    /**
     * @function
     * @description Open bonus product promo prompt dialog
     */
    loadBonusOption: function () {
        var    self = this,
            bonusDiscountContainer = document.querySelector('.bonus-discount-container');
        if (!bonusDiscountContainer) { return; }

        // get the html from minicart, then trash it
        var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
        bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

        dialog.open({
            html: bonusDiscountContainerHtml,
            options: {
                width: 400,
                title: Resources.BONUS_PRODUCT,
                buttons: [{
                    text: Resources.SELECT_BONUS_PRODUCTS,
                    closeOnEscape  : true,
                    click: function () {
                        var uuid = $('.bonus-product-promo').data('lineitemid'),
                            url = util.appendParamsToUrl(Urls.getBonusProducts, {
                                bonusDiscountLineItemUUID: uuid,
                                source: 'bonus',
                                format: 'ajax',
                                lazyLoad: 'false',
                                pageStart: 0,
                                pageSize: 10,
                                bonusProductsTotal: -1
                            });
                        $(this).dialog('close');
                        self.show(url);
                    }
                }, {
                    text: Resources.NO_THANKS,
                    click: function () {
                        $(this).dialog('close');
                    }
                }]
            },
            callback: function () {
                // show hide promo details
                $('.show-promo-details').on('click', function () {
                    $('.promo-details').toggleClass('visible');
                });
                $('.ui-widget-overlay').bind('click', function() { 
                    $('#bonus-product-dialog').dialog('close');
                });
            }
        });
    }
};

module.exports = bonusProductsView;
